import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu'
import { ComponentProps } from 'react'

import { cn } from '@/shared/lib'

type RootProps = ComponentProps<typeof DropdownMenuPrimitive.Root>
type ContentProps = ComponentProps<typeof DropdownMenuPrimitive.Content>
type ItemProps = ComponentProps<typeof DropdownMenuPrimitive.Item>
type TriggerProps = ComponentProps<typeof DropdownMenuPrimitive.Trigger>
type SeparatorProps = ComponentProps<typeof DropdownMenuPrimitive.Separator>

export const Root = ({ children, ...props }: RootProps) => {
  return (
    <DropdownMenuPrimitive.Root {...props}>
      {children}
    </DropdownMenuPrimitive.Root>
  )
}

export const Trigger = ({ children, ...props }: TriggerProps) => {
  return (
    <DropdownMenuPrimitive.Trigger {...props}>
      {children}
    </DropdownMenuPrimitive.Trigger>
  )
}

export const Content = ({
  side = 'bottom',
  sideOffset = 12,
  align = 'start',
  alignOffset = 0,
  children,
  className,
  ...props
}: ContentProps) => {
  return (
    <DropdownMenuPrimitive.Portal>
      <DropdownMenuPrimitive.Content
        className={cn(
          `z-dropdown rounded-lg bg-white py-3 shadow-[0px_0px_7px_0px_rgba(0,0,0,0.25)]`,
          className,
        )}
        side={side}
        sideOffset={sideOffset}
        align={align}
        alignOffset={alignOffset}
        {...props}
      >
        {children}
      </DropdownMenuPrimitive.Content>
    </DropdownMenuPrimitive.Portal>
  )
}

export const Item = ({ className, children, ...props }: ItemProps) => {
  return (
    <DropdownMenuPrimitive.Item
      className={cn(
        'typo-label1 block cursor-pointer px-3 py-2 text-black hover:bg-purple-50 hover:outline-none data-[highlighted]:font-medium',
        className,
      )}
      {...props}
    >
      {children}
    </DropdownMenuPrimitive.Item>
  )
}

export const Separator = ({
  className,
  children,
  ...props
}: SeparatorProps) => {
  return (
    <DropdownMenuPrimitive.Separator
      className={cn('my-3 h-[1px] bg-gray-100', className)}
      {...props}
    >
      {children}
    </DropdownMenuPrimitive.Separator>
  )
}
